import { Popover } from "@base-ui/react/popover"
import { QuestionMarkCircleIcon } from "@heroicons/react/16/solid"
import clsx from "clsx"
import type { ReactNode } from "react"

const HelperPopover = ({ children }: { children: ReactNode }) => {
  if (!children) return null

  return (
    <Popover.Root>
      <Popover.Trigger
        className={clsx(
          "flex size-7 shrink-0 items-center justify-center rounded-lg bg-transparent text-gray-500 transition-colors",

          "hover:bg-gray-100 hover:text-gray-700 focus-visible:bg-gray-100 focus-visible:text-gray-700 focus-visible:outline-none data-popup-open:bg-gray-100 data-popup-open:text-gray-700",

          "dark:text-gray-400 dark:data-popup-open:bg-gray-700 dark:data-popup-open:text-gray-200 dark:focus-visible:bg-gray-700 dark:focus-visible:text-gray-200 dark:hover:bg-gray-700 dark:hover:text-gray-200"
        )}
      >
        <QuestionMarkCircleIcon className="size-4" />
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Positioner collisionPadding={8} sideOffset={5}>
          <Popover.Popup
            className={clsx(
              "-outline-offset-1 flex max-w-80 origin-(--transform-origin) flex-col gap-2.5 text-pretty rounded-xl bg-gray-800 p-3 pt-2 font-medium text-sm/5 text-white shadow-xl outline-1 outline-white/5",

              "dark:bg-gray-950 dark:shadow-none dark:outline-white/10",

              "transition duration-100 ease-out",

              "data-starting-style:scale-95 data-starting-style:opacity-0",

              "data-ending-style:scale-95 data-ending-style:opacity-0 data-ending-style:duration-75 data-ending-style:ease-in"
            )}
          >
            {children}
          </Popover.Popup>
        </Popover.Positioner>
      </Popover.Portal>
    </Popover.Root>
  )
}

export default HelperPopover
